import { useColorModeValue } from '@ecoinvent/ui';
import { Handle, Position } from '@xyflow/react';
import type { NodeProps } from '@xyflow/react';

import { FlowsInput, FlowsOutput, FlowsType } from 'hooks/data/datasets/V4/flows/types';

import FlowGraphCard from './FlowGraphCard';

export type FlowNodeData = {
  flow: FlowsInput | FlowsOutput;
  direction: 'input' | 'output';
  flowType: FlowsType;
  handleId: string;
  onViewDataset?: () => void;
};

const wrapperStyle: React.CSSProperties = { cursor: 'default' };

const FlowNode = ({ data }: NodeProps) => {
  const { flow, direction, handleId, onViewDataset } = data as FlowNodeData;

  const handleBg = useColorModeValue('#D4D4D4', '#D4D4D4');
  const handleBorderColor = useColorModeValue('#FFFFFF', '#575454');

  const handleStyle: React.CSSProperties = {
    background: handleBg,
    border: `2px solid ${handleBorderColor}`,
    width: 8,
    height: 8,
    borderRadius: '50%',
    top: '50%',
    boxShadow: '0 1px 2px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.10)',
  };

  const leftHandle: React.CSSProperties = {
    ...handleStyle,
    transform: 'translate(calc(-50% - 6px), -50%)',
  };
  const rightHandle: React.CSSProperties = {
    ...handleStyle,
    transform: 'translate(calc(50% + 6px), -50%)',
  };

  return (
    <div className="nopan nodrag" style={wrapperStyle}>
      {direction === 'input' && <Handle id={handleId} type="source" position={Position.Right} style={rightHandle} />}
      {direction === 'output' && <Handle id={handleId} type="target" position={Position.Left} style={leftHandle} />}
      <FlowGraphCard variant="flow" flow={flow} direction={direction} onViewDataset={onViewDataset} />
    </div>
  );
};

export default FlowNode;
